<a class="fw-Navigation-paperless" matTooltip="{{'ICONS_TOOLTIP.GOPAPERLESS' | translate}}" href="javascript:void(0);"
    (click)="onClick('/nxi/settings/edelpreferences')" attr.aria-label="{{'NXI_NAVIGATION.GOPAPERLESS' | translate}}. {{'ICONS_TOOLTIP.GOPAPERLESS' | translate }}">
</a>
